<section class="home boxs">
    <app-sidebar></app-sidebar>
    <div class="homemain boxs homehover">
        <app-header></app-header>
        <app-calculator-widget></app-calculator-widget>
        <router-outlet></router-outlet>
    </div>
</section>
